import { createFileRoute, useParams } from '@tanstack/react-router';

import { TeachersTab } from '@/views/admin/courses/tabs/teachers-tab.tsx';

export const Route = createFileRoute('/admin/courses_/$id/teachers')({
  component: TeachersRoute,
});

function TeachersRoute() {
  const { id } = useParams({ from: '/admin/courses_/$id/teachers' });
  return <TeachersTab id={id} />;
}
